import { BrowserRouter, Route, Routes, Link } from 'react-router'
import { DataProvider } from './data'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { ApoyarPage } from './pages/ApoyarPage'
import { EquipoPage } from './pages/EquipoPage'
import { ExplorarPage } from './pages/ExplorarPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ProyectoPage } from './pages/ProyectoPage'
import { TerminosPage } from './pages/TerminosPage'

export default function App() {
  return (
    <BrowserRouter>
      <DataProvider>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<ExplorarPage />} />
            <Route path="/proyecto/:boletin" element={<ProyectoPage />} />
            <Route path="/terminos" element={<TerminosPage />} />
            <Route path="/equipo" element={<EquipoPage />} />
            <Route path="/apoyar" element={<ApoyarPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <Link to="/apoyar" className="fab-donate" title="Apoya este proyecto">
          <img src="/kofi-cup.png" alt="" className="fab-donate-icon" width={26} height={26} />
        </Link>
      </DataProvider>
    </BrowserRouter>
  )
}
